'use es6';

import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import HubAttributesData from 'AdsUI/data/HubAttributesData';
export default {
  fetch() {
    return dispatch => wrapReduxAction(HubAttributesData.fetch, 'HUB_ATTRIBUTES_FETCH', {
      dispatch
    });
  },

  save({
    key,
    value
  }) {
    return dispatch => wrapReduxAction(HubAttributesData.save.bind(null, {
      key,
      value
    }), 'HUB_ATTRIBUTES_SYNC', {
      dispatch
    });
  }

};